/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import AnimatedSidePopup from '../Animation/AnimatedSidePopup';
import GlobalContext from '../Context/GloablContext';
import ActionErrorToastMessage from '../ActionErrorToastMessage';
import Skeleton from '../../pages/ManageBranches/ManageBranchUser/ViewBranchUser/Skeleton';

const SidePopup = ({element, componentName, handleSidePopupClick, setOpenViewPopup,addOpen, actionErrorMessage,setActionErrorMessage,loadingPage,isViewBranchUser, popUp}) => {
    const { toastErrorMessage} = useContext(GlobalContext);
    const clickRef = useRef();
    const [isClass, setIsClass] = useState(false)
    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref to the element that needs
    to be clicked outside of, and a callback function to be executed when a click outside of that
    element occurs. In this case, it is used to close the side popup when the user clicks outside of
    it. The `clickRef` is a reference to the element that needs to be clicked outside of, and
    `setAddOpen(false)` is the callback function that sets the `addOpen` state to `false`, which
    closes the side popup. */
    useOnClickOutside(clickRef, () => {
        if(popUp === false && popUp === undefined) {
            if(toastErrorMessage === '') {
            
                if(isViewBranchUser){
                    setOpenViewPopup(false)
                }else{
                    handleSidePopupClick()
                }
            }
        }
    });
    const handleTime = () => {
        setTimeout(() => {
            setIsClass(true)
        }, [300]);
    }
    useEffect(() => {
        if(actionErrorMessage !== "" && setActionErrorMessage) {
            const timer = setTimeout(() => {
                setActionErrorMessage('')
            }, 7000);
    
            return () => {
                clearTimeout(timer);
            };
        }
        handleTime();
    }, [actionErrorMessage]);
    return (
        <div className={`${isClass ? "fixed top-0 left-0 w-full h-full bg-[#000] bg-opacity-50 z-[999]" : ''}`}>
            <AnimatedSidePopup
                isOpen={addOpen}
                child={
                    <div ref={clickRef} className={`absolute px-4 py-3 ${actionErrorMessage !== undefined &&  actionErrorMessage !== "" ? "pt-[60px]" : ""} top-0 right-0 modal-content border-none bg-[#ffffff] 
                            w-[500px] z-[9999] flex flex-col pointer-events-auto bg-clip-padding outline-none text-current h-screen`}>
                        <div className='overflow-x-hidden overflow-y-auto h-full'>
                            {actionErrorMessage !== undefined &&  actionErrorMessage !== "" && <ActionErrorToastMessage message={actionErrorMessage} />}
                            <div className="sticky top-0 left-0 bg-[#FFF] z-10">
                                <div className={`flex items-center justify-between pt-3 pr-[16px] pb-4 
                                bg-[#C2DCEF] bg-opacity-[58%] rounded-[3px] ${componentName === "View User" ? "pl-[13px]" : "pl-4"}`}>
                                    <h5 className="pageHeader addadmin"
                                    >{componentName}</h5>
                                    <button
                                        type="button"
                                        onClick={() => handleSidePopupClick()}
                                        className="opacity-60 hover:opacity-80 focus:opacity-100 focus:shadow-none focus:outline-none"
                                    >
                                        <span>
                                            <img loading="lazy" decoding="async" src="/images/modalClose.svg" alt="icon"/>
                                        </span>
                                    </button>
                                </div>
                            </div>
                            {isViewBranchUser&&loadingPage?<Skeleton/>:element}
                        </div> 
                    </div>
                }/>
        </div>
                
    );
}

export default SidePopup;
